{
  "commodityFormElements": {
    "formRows": [
      {
        "formGroups": [
          {
            "control": {
              "label": "name",
              "displayLabel": "Commodity Name",
              "placeHolder": "Enter name",
              "fieldInfo": {
                "dataType": "text"
              },
              "validators": [
                {
                  "type": "required",
                  "message": "Name is required"
                }
              ]
            }
          },
          {
            "control": {
              "label": "code",
              "displayLabel": "Commodity Code",
              "placeHolder": "Enter Code",
              "fieldInfo": {
                "dataType": "text"
              },
              "validators": [
                {
                  "type": "required",
                  "message": "Code is required"
                }
              ]
            }
          },
          {
            "control": {
              "label": "commodityCategory",
              "displayLabel": "Commodity Category",
              "placeHolder": "Entry Commodity Category Name",
              "returnRawValue": true,
              "fieldInfo": {
                "dataType": "picklist",
                "lookupDetails": {
                  "apiUrl": "v1/commodity-categories/list",
                  "filterByKeys": ["NAME_CONTAINS", "CODE_CONTAINS"],
                  "limit": 10,
                  "orderBy": { "name": "asc" },
                  "bindLabel": "name",
                  "bindValue": "id",
                  "additionalFilters": [
                    {
                      "name": "ACTIVE_EQUALS",
                      "alias": "ACTIVE_EQUALS",
                      "value": ["true"]
                    }
                  ],
                  "displayColumns": [{ "key": "name", "header": "Name" }]
                }
              },
              "validators": [
                {
                  "type": "required",
                  "message": "Commodity Category is required"
                }
              ]
            }
          }
        ]
      },
      {
        "formGroups": [
          {
            "control": {
              "label": "hasImdgDetails",
              "displayLabel": "IMDG Details",
              "fieldInfo": {
                "dataType": "boolean"
              }
            }
          }
        ]
      }
    ]
  },
  "imdgDetailsFormElements": {
    "formRows": [
      {
        "formGroups": [
          {
            "control": {
              "label": "lastName",
              "displayLabel": "Last Name",
              "placeHolder": "Enter Last Name",
              "fieldInfo": {
                "dataType": "text"
              }
            }
          },
          {
            "control": {
              "label": "flashPoint",
              "displayLabel": "Flash Point",
              "placeHolder": "Enter Flash Point",
              "fieldInfo": {
                "dataType": "text"
              }
            }
          },
          {
            "control": {
              "label": "imdgClass",
              "displayLabel": "IMDG Class",
              "placeHolder": "Enter IMDG Class",
              "fieldInfo": {
                "dataType": "text"
              }
            }
          },
          {
            "control": {
              "label": "properShippingName",
              "displayLabel": "Proper Shipping Name",
              "placeHolder": "Enter Proper Shipping Name",
              "fieldInfo": {
                "dataType": "text"
              }
            }
          }
        ]
      },
      {
        "formGroups": [
          {
            "control": {
              "label": "ems",
              "displayLabel": "EMS",
              "placeHolder": "Enter EMS",
              "fieldInfo": {
                "dataType": "text"
              }
            }
          },
          {
            "control": {
              "label": "packagingInstruction",
              "displayLabel": "Packaging Instruction",
              "placeHolder": "Enter Packaging Instruction",
              "fieldInfo": {
                "dataType": "text"
              }
            }
          },
          {
            "control": {
              "label": "codedStowage",
              "displayLabel": "Coded Stowage",
              "placeHolder": "Enter Coded Stowage",
              "fieldInfo": {
                "dataType": "text"
              }
            }
          },
          {
            "control": {
              "label": "ibcProvisions",
              "displayLabel": "IBC Provisions",
              "placeHolder": "Enter IBC Provisions",
              "fieldInfo": {
                "dataType": "text"
              }
            }
          }
        ]
      },
      {
        "formGroups": [
          {
            "control": {
              "label": "tankInstructions",
              "displayLabel": "Tank Instructions",
              "placeHolder": "Enter Tank Instructions",
              "fieldInfo": {
                "dataType": "text"
              }
            }
          },
          {
            "control": {
              "label": "properties",
              "displayLabel": "Properties",
              "placeHolder": "Enter Properties",
              "fieldInfo": {
                "dataType": "text"
              }
            }
          },
          {
            "control": {
              "label": "exempted",
              "displayLabel": "Exempted",
              "placeHolder": "Select Exempted",
              "fieldInfo": {
                "dataType": "select",
                "options": [
                  { "label": "Yes", "value": true },
                  { "label": "No", "value": false }
                ]
              }
            }
          }
        ]
      },
      {
        "formGroups": [
          {
            "control": {
              "label": "unoCode",
              "displayLabel": "UNO Code",
              "placeHolder": "Enter UNO Code",
              "fieldInfo": {
                "dataType": "text"
              }
            }
          },
          {
            "control": {
              "label": "unno",
              "displayLabel": "UNNO",
              "placeHolder": "Enter UNNO",
              "fieldInfo": {
                "dataType": "text"
              }
            }
          },
          {
            "control": {
              "label": "flashPointUnitIndicator",
              "displayLabel": "Flash Point Unit Indicator",
              "placeHolder": "Enter Flash Point Unit Indicator",
              "fieldInfo": {
                "dataType": "text"
              }
            }
          }
        ]
      },
      {
        "formGroups": [
          {
            "control": {
              "label": "variant",
              "displayLabel": "Variant",
              "placeHolder": "Enter Variant",
              "fieldInfo": {
                "dataType": "text"
              }
            }
          },
          {
            "control": {
              "label": "subsidiaryRiskLabel1",
              "displayLabel": "Subsidiary Risk Label 1",
              "placeHolder": "Enter Subsidiary Risk Label 1",
              "fieldInfo": {
                "dataType": "text"
              }
            }
          },
          {
            "control": {
              "label": "materialState",
              "displayLabel": "Material State",
              "placeHolder": "Enter Material State",
              "fieldInfo": {
                "dataType": "text"
              }
            }
          }
        ]
      },
      {
        "formGroups": [
          {
            "control": {
              "label": "packagingGroup",
              "displayLabel": "Packaging Group",
              "placeHolder": "Enter Packaging Group",
              "fieldInfo": {
                "dataType": "text"
              }
            }
          },
          {
            "control": {
              "label": "packagingProvision",
              "displayLabel": "Packaging Provision",
              "placeHolder": "Enter Packaging Provision",
              "fieldInfo": {
                "dataType": "text"
              }
            }
          },
          {
            "control": {
              "label": "stowageCategory",
              "displayLabel": "Stowage Category",
              "placeHolder": "Enter Stowage Category",
              "fieldInfo": {
                "dataType": "text"
              }
            }
          }
        ]
      },
      {
        "formGroups": [
          {
            "control": {
              "label": "imoTankInstructions",
              "displayLabel": "IMO Tank Instructions",
              "placeHolder": "Enter IMO Tank Instructions",
              "fieldInfo": {
                "dataType": "text"
              }
            }
          },
          {
            "control": {
              "label": "stowSegregation",
              "displayLabel": "Stow Segregation",
              "placeHolder": "Enter Stow Segregation",
              "fieldInfo": {
                "dataType": "text"
              }
            }
          },
          {
            "control": {
              "label": "lineTariffCode",
              "displayLabel": "Line Tariff Code",
              "placeHolder": "Enter Line Tariff Code",
              "fieldInfo": {
                "dataType": "text"
              }
            }
          }
        ]
      },
           {
             "formGroups": [
               {
                 "control": {
                   "label": "limitedQuantity",
                   "displayLabel": "Limited Quantity",
                   "placeHolder": "Enter limited Quantity",
                   "fieldInfo": {
                     "dataType": "text"
                   }
                 }

               },
               {
                 "control": {
                   "label": "specialProvision",
                   "displayLabel": "Special Provision",
                   "placeHolder": "Enter Special Provision",
                   "fieldInfo": {
                     "dataType": "text"
                   }
                 }

               },
               {
                 "control": {
                   "label": "cargoProvision",
                   "displayLabel": "Cargo Provision",
                   "placeHolder": "Enter Cargo Provision",
                   "fieldInfo": {
                     "dataType": "text"
                   }
                 }

               }
             ]
           },
            {
              "formGroups": [
                {
                  "control": {
                    "label": "ibcInstructions",
                    "displayLabel": "Ibc Instructions",
                    "placeHolder": "Enter Ibc Instructions",
                    "fieldInfo": {
                      "dataType": "text"
                    }
                  }

                },
                {
                  "control": {
                    "label": "unTankInstructions",
                    "displayLabel": "UnTank Instructions",
                    "placeHolder": "Enter UnTank Instructions",
                    "fieldInfo": {
                      "dataType": "text"
                    }
                  }

                },
                {
                  "control": {
                    "label": "observations",
                    "displayLabel": "Observations",
                    "placeHolder": "Enter Observations",
                    "fieldInfo": {
                      "dataType": "text"
                    }
                  }

                }
              ]
            }
    ]
  }
}
